<template>
	<div class="box">
		<div>
			<div class="numDoctor">
				<div>
					<el-input
					    placeholder="请输入内容"
					    prefix-icon="el-icon-search"
					    v-model="input2">
					  </el-input>
				</div>
				<div class="gjjiansuo">
					<span @click="jsFn('')">全部</span>
					<span @click="jsFn('常见问题')" :class="{'active':yjfl=='常见问题'}">常见问题</span>
					<span @click="jsFn('牙齿矫正')" :class="{'active':yjfl=='牙齿矫正'}">牙齿矫正</span>
					<span @click="jsFn('牙齿修复')" :class="{'active':yjfl=='牙齿修复'}">牙齿修复</span>
					<span @click="jsFn('儿童口腔')" :class="{'active':yjfl=='儿童口腔'}">儿童口腔</span>
					<span @click="jsFn('牙齿养护')" :class="{'active':yjfl=='牙齿养护'}">牙齿养护</span>
					<span @click="jsFn('病友说')" :class="{'active':yjfl=='病友说'}">病友说</span>
					<span @click="jsFn('其他')" :class="{'active':yjfl=='其他'}">其他</span>
				</div>
				<div class="gjjiansuo" style="margin-top: -20px;">
					<span @click="js1Fn('')">全部</span>
					<span @click="js1Fn(1)" :class="{'active':isfree=='1'}">免费</span>
					<span @click="js1Fn(0)" :class="{'active':isfree=='0'}">收费</span>
				</div>
				<div class="btn">
					<button @click="doctors_artcles_tjFn">搜索</button>
				</div>
				<div class="btn">
					<button @click="shujuBool=true">文章阅读量排名统计</button>
				</div>
				<div class="btn">
					<button @click="wztsBool=true">文章推送与分享</button>
				</div>
			</div>
			<div class="chartsDoc1">
				<ul class="tableHeader tableHeaderbox">
					<li v-for="item in tableList">{{item.tableName}}</li>
				</ul>
				<!--  -->
				<div class="tabletd">
					<ul class="tablecontent tableHeader" v-for="item in row">
						<li>{{item.aTitle}}</li>
						<li>{{item.tPid_name}}</li>
						<li>{{item.tName}}</li>
						<li>{{item.aViewNum}}</li>
						<li>{{item.aSharedNum}}</li>
						<li>
							<div class="btns">
								<button>设置爆文</button>
							</div>
							<div v-if="item.aIsFree==0" class="btns" @click="doctors_artcles_setfreeFn(item.id,1)">
								<button>免费</button>
							</div>
							<div v-if="item.aIsFree==1" class="btns" @click="doctors_artcles_setfreeFn(item.id,0)">
								<button style="background:#F56C6C ;">取消免费</button>
							</div>
							
						</li>
					</ul>
					<div class="list-more">
						<p>暂无更多数据</p>
					</div>
				</div>
			</div>
		</div>
		<div class="shuju" v-show="shujuBool">
			<i class="el-icon-close" @click="shujuBool=false" title="关闭弹窗"></i>
			<div class="chartsDoc">
				<div class="chartsDocheader">
					<div>
						<el-date-picker
						    v-model="value2"
						    type="daterange"
						    range-separator="至"
						    start-placeholder="开始月份"
						    end-placeholder="结束月份"
						    value-format="yyyy-MM-dd"
						    @blur="date1Fn()">
					    </el-date-picker>
					</div>
					<div class="datebtn">
						<div :class="btn1Str==7?'active':''" @click="day1Fn(7)">近7日</div>
						<div :class="btn1Str==30?'active':''" @click="day1Fn(30)">近30日</div>
					</div>
				</div>
				<div class="chartsDoccontent">
					<div>
						<zxxyEchart :type="2" :options1="options1"  :dates="value2"  :name="name1" :zsoption="sqltop"></zxxyEchart>
					</div>
					<div>
						<zxxyEchart :type="2" :options1="options1"  :dates="value2"  :name="name2" :zsoption="sqllast"></zxxyEchart>
					</div>
				</div>
			</div>
		</div>
		<div class="shuju" v-show="wztsBool">
			<i class="el-icon-close" @click="wztsBool=false" title="关闭弹窗"></i>
			<div class="chartsDoc">
				<div class="chartsDocheader">
					<div>
						<el-date-picker
						    v-model="value3"
						    type="daterange"
						    range-separator="至"
						    start-placeholder="开始月份"
						    end-placeholder="结束月份"
						    value-format="yyyy-MM-dd"
						    @blur="date2Fn()">
					    </el-date-picker>
					</div>
					<div class="datebtn">
						<div :class="btn2Str==7?'active':''" @click="day2Fn(7)">近7日</div>
						<div :class="btn2Str==30?'active':''" @click="day2Fn(30)">近30日</div>
					</div>
				</div>
				<div class="chartsDoccontent">
					<div>
						<zxxyEchart :type="2" :options1="options1"  :dates="value2"  :name="name3" :zsoption="sqlfxts"></zxxyEchart>
					</div>
					<div>
						<zxxyEchart :type="2" :options1="options1"  :dates="value2"  :name="name4" :zsoption="sqlfxzs"></zxxyEchart>
					</div>
					
				</div>
				<div class="chartsDoccontent">
					<div>
						<zxxyEchart :type="2" :options1="options1"  :dates="value2"  :name="name5" :zsoption="sqlhbfxts"></zxxyEchart>
					</div>
					<div>
						<!--<zxxyEchart :type="2" :options1="options1"  :dates="value2"  :name="name4" :zsoption="sqlfxzs"></zxxyEchart>-->
					</div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {yht_wmp_pushartclestj,doctors_artcles_tj,yht_artcles_top10,yht_artcles_last10,doctors_artcles_setfree} from '../components/http/api.js'
	import zxEchart from '../component/zxEchart.vue'
	import zxxyEchart from '../component/zxxyEchart.vue'
	export default{
		components:{
			zxEchart,
			zxxyEchart
		},
		data(){
			return{
				input2:'',
				tableList:[{
					tableName: '文章名称',
				}, {
					tableName: '一级分类',
				}, {
					tableName: ' 二级分类',
				}, {
					tableName: '累计阅读量',
				}, {
					tableName: '累计分享量',
				}, {
					tableName: '设置爆文',
				}],
				value1:1,
				options1:[{
					id:'1',
					name:'正畸诊断报告',
				},{
					id:'2',
					name:'患者健康检查报告',
				},{
					id:'3',
					name:'患者沟通报告',
				},{
					id:'4',
					name:'正畸治疗对比报告',
				}],
				options2:[{
					id:1,
					name:'专家审阅',
				},{
					id:2,
					name:'分享案例',
				}],
				hzNum:'',
				name1:'阅读量Top10文章',
				name2:'阅读量Last10文章',
				name3:'每日文章推送与分享',
				name4:'参与分享的牙医总数',
				name5:'海报推送与分享',
				name6:'参与海报分享的牙医总数',
				row:[],
				sqltop:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0],
		                show:false
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '阅读量',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)']
		        },
		        sqllast:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0],
		                show:false
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '阅读量',
		                type: 'bar',
		                data: [0,0,0,0],
		                show:false
		            }],
		            color: ['rgba(29,181,255,1)']
		        },
		        sqlfxts:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0],
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '推送人数',
		                type: 'bar',
		                data: [0,0,0,0]
		            },{
		                name: '分享人数',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)','#F56C6C']
		        },
		         sqlfxzs:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0],
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '参与分享的牙医',
		                type: 'line',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)']
		        },
		        sqlhbfxts:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0],
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '推送人数',
		                type: 'bar',
		                data: [0,0,0,0]
		            },{
		                name: '分享人数',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)','#F56C6C']
		        },
		        btn1Str:7,
		        btn2Str:7,
		        value2:'',
		        yjfl:'',
		        shujuBool:false,
		        isfree:'',
		        wztsBool:''
			}
		},
		beforeMount() {
			this.doctors_artcles_tjFn();
			this.value2=[this.getDay(-7),this.getDay(-1)];
			this.value3=[this.getDay(-7),this.getDay(-1)];
			this.yht_artcles_top10Fn();
			this.yht_artcles_last10Fn();
			this.yht_wmp_pushartclestjFn();
		},
		methods:{
			doctors_artcles_setfreeFn(id,a){
				var data = {
					id:id,
					isfree:a
				}
				doctors_artcles_setfree(data).then(res=>{
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1000,
						onClose: () => {
							this.doctors_artcles_tjFn();
						}
					})
				})
			},
			jsFn(str){
				this.yjfl=str;
				this.doctors_artcles_tjFn()
			},
			js1Fn(str){
				this.isfree=str;
				this.doctors_artcles_tjFn()
			},
			date1Fn(){
				this.yht_artcles_top10Fn();
				this.yht_artcles_last10Fn();
			},
			doctors_artcles_tjFn(){
				this.row=[];
				var data = {
					key_name:this.input2,
					isfree:this.isfree,
				}
				doctors_artcles_tj(data).then(res=>{
					if(this.yjfl==''){
						this.row=res.data;
					}else{
						for(var i=0;i<res.data.length;i++){
							if(res.data[i].tPid_name==this.yjfl||res.data[i].tName==this.yjfl){
								this.row.push(res.data[i]);
							}
						}
					}
				})
			},
			day1Fn(i){
				this.btn1Str=i;
				this.value2=[this.getDay(-i),this.getDay(-1)];
				this.yht_artcles_top10Fn();
				this.yht_artcles_last10Fn();
			},
			day2Fn(i){
				this.btn2Str=i;
				this.value3=[this.getDay(-i),this.getDay(-1)];
				this.yht_wmp_pushartclestjFn();
			},
			getDay(day){
			    var today = new Date();
			    var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
			    today.setTime(targetday_milliseconds); //注意，这行是关键代码
			    var tYear = today.getFullYear();
			    var tMonth = today.getMonth();
			    var tDate = today.getDate();
			    tMonth = this.doHandleMonth(tMonth + 1);
			    tDate = this.doHandleMonth(tDate);
			    return tYear+"-"+tMonth+"-"+tDate;
			},
			doHandleMonth(month){
			    var m = month;
			    if(month.toString().length == 1){
			     m = "0" + month;
			    }
			    return m;
			},
			yht_artcles_top10Fn(){
				var data={
					start_time:this.value2[0],
					end_time:this.value2[1]
				}
				yht_artcles_top10(data).then(res=>{
					var data = res.data;
					var arr1=[];
					var arr2=[];
					for(var i =0;i<data.length;i++){
						arr1.push(data[i].aTitle);
						arr2.push(data[i].aViewNum);
					}
					console.log(arr1);
					console.log(arr2);
					this.sqltop.xAxis.data=arr1;
					this.sqltop.series[0].data=arr2;
				})
			},
			yht_artcles_last10Fn(){
				var data={
					start_time:this.value2[0],
					end_time:this.value2[1]
				}
				yht_artcles_last10(data).then(res=>{
					var data = res.data;
					var arr1=[];
					var arr2=[];
					for(var i =0;i<data.length;i++){
						arr1.push(data[i].aTitle);
						arr2.push(data[i].aViewNum);
					}
					console.log(arr1);
					console.log(arr2);
					this.sqllast.xAxis.data=arr1;
					this.sqllast.series[0].data=arr2;
				})
			},
			yht_wmp_pushartclestjFn(){
				var data={
					start_time:this.value3[0],
					end_time:this.value3[1]
				}
				yht_wmp_pushartclestj(data).then(res=>{
					var data = res.data;
					var arr1=[];
					var arr2=[];
					var arr3=[];
					var arr4=[];
					var arr5=[];
					var arr6=[];
					for(var i =0;i<data.length;i++){
						arr1.push(data[i].paName);
						arr4.push(data[i].paDoctorsCount);
						arr2.push(data[i].paPushedCount-data[i].paPushedKPHBCount);
						arr3.push(data[i].paSharedCount-data[i].paSharedKPHBCount);
						arr5.push(data[i].paPushedKPHBCount);
						arr6.push(data[i].paSharedKPHBCount);
					}
					this.sqlfxts.xAxis.data=arr1;
					this.sqlfxts.series[0].data=arr2;
					this.sqlfxts.series[1].data=arr3;
					
					this.sqlfxzs.xAxis.data=arr1;
					this.sqlfxzs.series[0].data=arr4;
					
					this.sqlhbfxts.xAxis.data=arr1;
					this.sqlhbfxts.series[0].data=arr5;
					this.sqlhbfxts.series[1].data=arr6;
					
					
				})
			}
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
		position: relative;
	}
	.box>div{
		height:100%;
		width: 100%;
		display: flex;
		justify-content: space-between;
		/*background: #FFFFFF;*/
	}
	
	.box>div:nth-child(1){
		margin-bottom: 7px;
	}
	.box>div:nth-child(2){
		display: flex;
		justify-content: center;
	}
	.box>div:nth-child(3){
		display: flex;
		justify-content: center;
	}
	.box{
		
	}
	.numDoctor{
		width: 212px;
		height: 720px;
		padding:10px 20px;
		border-radius:3px;
		/*border-right: 3px solid rgba(198,198,198,1);*/
		background: #FFFFFF;
	}
	.text1,.text2{
		margin-bottom: 30px;
	}
	.text1>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text1>p:nth-child(2){
		font-size:30px;
		font-weight:600;
		color:rgba(74,74,74,1);
		margin-top: 8px;
		line-height:23px;
	}
	.text2>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text2>p:nth-child(2){
		margin-top: 8px;
		font-size:30px;
		font-weight:600;
		color:rgba(29,181,255,1);
		line-height:23px;
	}
	.chartsDoc{
		width:1035px;
		/*height:344px;*/
		padding: 10px 20px;
		background:rgba(255,255,255,1);
		border-radius:3px;
		position: relative;
	}
	.chartsDoc1{
		width:1075px;
		height:720px;
		padding: 10px 0px;
		background:rgba(255,255,255,1);
		border-radius:3px;
		position: relative;
	}
	.chartsDocheader{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.chartsDocheader>div:nth-child(1){
		width: 400px;
	}
	.chartsDocheader>div:nth-child(1)>div{
		width: 400px;
	}
	.datebtn>div:hover{
		border:1px solid yellow;
		
	}
	.datebtn{
		display: flex;
	}
	.datebtn>div{
		margin-right: 13px;
		cursor: pointer;
		width:93px;
		height:42px;
		background:rgba(234,234,234,1);
		border-radius:24px;
		border:1px solid rgba(221,227,232,1);
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:24px;
		display: flex;justify-content: center;
		align-items: center;
	}
	.datebtn>div.active{
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:24px;
		background:rgba(29,181,255,1);
	}
	.chartsDoccontent{
		display: flex;
		justify-content: space-between;
	}
	.chartsDoccontent>div{
		width:497px;
		height: 290px;
		margin-top: 10px;
		/*background: #CCCCCC;*/
	}
	.btn{
		margin-top: 20px;
	}
	.btn:hover button{
		border: 1px solid yellow;
	}
	.btn>button{
		width: 100%;
		height: 40px;
        background: rgba(0, 120, 255, 1);
	    color: #FFFFFF;
	    font-size: 16px;
	    border-radius: 3px;
	}
	
	.tableHeader {
		width: 100%;
		height: 20px;
		border-bottom: 2px solid rgba(119, 151, 178, 0.16);
		;
	}
	.tablecontent {
		margin-top: 0;
		width: 100%;
		height: 140px;
		border-bottom: 3px solid #FFFFFF;
		position: relative;
		background: #F5F5F5;
	}
	
	.tablecontent::before {
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 2;
		background: #FFFFFF;
	}
	
	.tablecontent::after {
		content: "";
		display: block;
		position: absolute;
		bottom: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 2;
		background: #FFFFFF;
	}
	
	.tableHeader li {
		height: 30px;
	}
	
	.tableHeader li,
	.tablecontent li {
		float: left;
		text-align: center;
		font-size: 12px;
		color: #9B9B9B;
	}
	
	.tablecontent li {
		height: 140px;
		line-height: 140px;
		position: relative;
		color: #9B9B9B;
		z-index: 3;
		overflow: hidden;
	}
	
	.tablecontent li::before {
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 2px;
		height: 118px;
		border-left: 2px dashed #D7D9DC;
		/*px*/
	}
	
	.tablecontent li:nth-child(1)::before {
		border: none;
	}
	
	.tablecontent li:nth-child(1) {
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	
	.tablecontent li:nth-child(1)>p {
		margin: 0 10px;
		word-wrap: break-word;
		word-break: break-all
	}
	
	.tablecontent li:nth-child(2)::before {}
	
	.tableHeader li:nth-child(1) {
		width: 20%;
	}
	
	.tableHeader li:nth-child(2) {
		width: 15%;
	}
	
	.tableHeader li:nth-child(3) {
		width: 15%;
	}
	.tableHeader li:nth-child(3).tableA{
		width: 15%;
		display: flex;
		flex-wrap: wrap;
 		align-content:center;
 		align-items: center;
 		justify-content: center;
	}
	.tableHeader li:nth-child(3)>P{
		height: 15px;
		line-height: 15px !important;
		width: 100%;
		margin: 3px;
	}
	.tableHeader li:nth-child(4) {
		width: 15%;
	}
	
	.tablecontent li:nth-child(4) {
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	
	.tablecontent li:nth-child(4)>p {
		margin: 0 10px;
		word-wrap: break-word;
		word-break: break-all
	}
	
	.tableHeader li:nth-child(5) {
		width: 15%;
	}
	.tableHeader li:nth-child(6) {
		width: 20%;
	}
	.tableHeader li:nth-child(6) {
		width: 20%;
	}
	.tablecontent li:nth-child(6){
		text-align: center;
	}
	.tableHeader li:nth-child(6)>div:nth-child(1){
		margin-top: 30px;
	}
	.tableHeader li:nth-child(6)>div {
		width: 126px;
		height: 30px;
		margin: 0 auto;
		margin-top: 20px;
	}
	
	.tableHeader li:nth-child(6)>div:hover button {
		border: 1px solid yellow;
	}
	
	.tableHeader li:nth-child(6)>div>button {
		width: 126px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 16px;
		float: left;
	}
	
	.tabletd {
		/*position: absolute;
		top: 30px;
		left: 0;*/
		overflow: auto;
		background: #F5F5F5;
		width: 100%;
		height: 700px;
	}
	.list-more {
		width: 100%;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}
	.gjjiansuo{
		/*margin-left:27px ;*/
		/*display: none;*/
		overflow: hidden;
		margin-top: 11px;
		margin-bottom: 30px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.gjjiansuo>span{
		display: block;
		margin-top: 10px;
		font-size:13px;
		font-weight:500 !important;
		color:rgba(215,215,215,1);
		margin-right: 16px;
		cursor: pointer;
		border-bottom: 1px solid #D7D7D7;
	}
	.gjjiansuo>span.active{
		color: rgba(0,120,255,1);
		border-bottom: 1px solid rgba(0,120,255,1);
	}
	.gjjiansuo>span:hover{
		color: rgba(0,120,255,1);
		border-bottom: 1px solid rgba(0,120,255,1);
	}
	.shuju{
		position: absolute;
		top: 0;
		right: 0;
		z-index: 1999;
		background: rgba(0,0,0,.5);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.shuju .el-icon-close{
		color: #FFFFFF;
		font-size: 40px;
		font-weight: bold;
		position: absolute;
		top: 20px;
		right: 20px;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/component/wzDate.vue